import React from 'react';
import { color } from '@starrez/starryui9';
import { ICellRenderer } from '../types';
import styled from 'styled-components';
import { strings } from '../../../localisation';
import { ShieldPositiveFlag } from '@starryui10/images/icons/ShieldPositiveFlag';
import { ShieldNegativeFlag } from '@starryui10/images/icons/ShieldNegativeFlag';
import { Tooltip } from '@starryui10/Components/Tooltip';

interface ISituationResponseFlagColumnProps extends ICellRenderer<starrez.SituationResponseEnum> {
    value: starrez.SituationResponseEnum;
}

export const SituationResponseFlagColumn = ({ value }: ISituationResponseFlagColumnProps) => {
    if (value === 'NO_RESPONSE') return null;

    return (
        <Tooltip offset={[0, 0]} caption={value === 'OKAY' ? strings.Label_SituationResponseOK : strings.Label_SituationResponseNotOK}>
            {(display) => (
                <StyledWrapper onMouseEnter={() => display(true)} onMouseLeave={() => display(false)}>
                    {value === 'OKAY' && <ShieldPositiveFlag color={color.Green.G60} />}
                    {value === 'NOT_OKAY' && <ShieldNegativeFlag color={color.Red.R60} />}
                </StyledWrapper>
            )}
        </Tooltip>
    );
};

const StyledWrapper = styled.div`
    height: 100%;
    cursor: pointer;
    width: 100%;
    display: inline-flex;
    align-items: center;

    > * {
        cursor: pointer !important;
    }
`;
